export const downloadBlob = (data: Blob, fileName: string) => {
    const link = document.createElement('a');
    const downloadLink = window.URL.createObjectURL(data);

    link.setAttribute('download', fileName);
    link.style.display = 'none';
    link.href = downloadLink;

    document.body.appendChild(link);
    link.click();

    window.URL.revokeObjectURL(link.href);
    document.body.removeChild(link);
};
